// extracted by mini-css-extract-plugin
module.exports = {"Container":"ShareLinkNavbar_Container__31zOj","Logo":"ShareLinkNavbar_Logo__1tD4m"};